import { createDataWidget } from "@/widgets/common/createDataWidget";
import { fetchDashboardMockData } from "../mockDashboard";
import type { TimeChartEvent } from "../dashboardResponse";

/**
 * Widget state via the shared factory (D11): thunk + slice + selectors in
 * one declaration. The fetcher reads the Gantt section
 * (`data.time_chart_events`) from the page's dashboard response; swapping
 * in CubeJS is a body-only change here.
 */
export const runningStatusChart = createDataWidget<TimeChartEvent>({
  name: "runningStatusChart",
  fetcher: async () => {
    const response = await fetchDashboardMockData();
    return response.data.time_chart_events;
  },
});
